<template>
  <div>
    <el-container>
      <el-header></el-header>
      <el-main>
        <div :class="[isPc ? 'body-center body-width-pc' : 'body-center body-width-mb']">
          <img width="300" src="https://cdn.jsdelivr.net/gh/CareyWang/MyUrls@master/public/logo.png">
          <el-input ref="long" v-model="longUrl" size="medium" @keyup.enter.native="enterToDoShort"
                    clearable>
            <div slot="append">
              <el-button icon="el-icon-view" @click="openNewPage(longUrl)">
                访问
              </el-button>
              <el-button type="danger" icon="el-icon-magic-stick" @click="doShort" :loading="loading">
                缩短
              </el-button>
            </div>

          </el-input>
          <el-input ref="shortUrl" class="copy-content" v-model="shortUrl"
                    clearable
                    size="medium">
            <div slot="append">
              <el-button icon="el-icon-view" @click="openNewPage(shortUrl)">
                访问
              </el-button>
              <el-button v-clipboard:copy="shortUrl" v-clipboard:success="onCopy" ref="copy-btn"
                         icon="el-icon-document-copy">
                复制
              </el-button>
            </div>

          </el-input>

          <div style="text-align: center;">
            <el-row :gutter="10">
              <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                <el-input style="width: 100%;" v-model.trim="shortUrlLength" type="number"
                          placeholder="请填写自定义短连接位数" size="medium">
                  <div slot="append">
                    <el-button icon="el-icon-view">
                      自定义短连接位数
                    </el-button>
                  </div>
                </el-input>
              </el-col>
            </el-row>
          </div>


        </div>
      </el-main>
    </el-container>
  </div>
</template>

<script>
const repo = process.env.VUE_APP_PROJECT
const backend = process.env.VUE_APP_MYURLS_CUSTOM_API

export default {
  data() {
    return {
      isPc: true,

      loading: false,
      longUrl: '',
      shortUrl: '',
      shortUrlLength: 20,
    };
  },
  watch: {
    longUrl: {
      handler(newValue, oldValue) {
        if (newValue) {
          this.saveToLocalStorage()
        }
      },
      immediate: true,
    }
  },

  created() {
    const os = this.getOS()
    if (os.isPc !== true) {
      this.isPc = false
    }
  },
  mounted() {
    this.$refs.long.focus()
    this.getToLocalStorage()
  },
  methods: {

    // 保存longUrl到localStorage
    saveToLocalStorage() {
      if (this.longUrl) {
        localStorage.setItem('SESSION_LONG_URL_KEY', btoa(this.longUrl))
      }
    },

    // 保存longUrl到localStorage
    getToLocalStorage() {
      let sessionLongUrl = localStorage.getItem('SESSION_LONG_URL_KEY')
      if (sessionLongUrl) {
        this.longUrl = atob(sessionLongUrl);
      }
    },

    // 在新页面打开链接
    openNewPage(url) {
      if (url) {
        window.open(url, '_blank');
      }
    }
    ,

    enterToDoShort(ev) {
      ev.keyCode === 13 && this.doShort()
    },
    doShort() {
      let re = new RegExp('http(s*)://[^\s]*')
      if (re.exec(this.longUrl) === null) {
        this.$message.warning('请输入正确格式的长链接')
        return
      }

      this.loading = true

      this.saveToLocalStorage()

      let data = new FormData();
      data.append("longUrl", btoa(this.longUrl));
      //data.append("shortKey", this.shortUrl.indexOf('http') < 0 ? this.shortUrl : '');
      data.append("shortKey", this.generateRandomId(this.shortUrlLength));

      // console.log('longUrl: ', btoa(this.longUrl))
      // console.log('shortKey: ', this.generateRandomId(this.shortUrlLength))

      this.$axios.post(backend, data, {
        header: {
          "Content-Type": "application/form-data; charset=utf-8"
        }
      })
          .then(res => {
            if (res.data.Code === 1 && res.data.ShortUrl !== "") {
              this.shortUrl = res.data.ShortUrl;
              this.$copyText(this.shortUrl)
              this.$message.success("短链接已复制到剪贴板");
            } else {
              this.$message.error("短链接获取失败：" + res.data.Message);
            }
          })
          .catch(() => {
            this.$message.error("短链接获取失败");
          })
          .finally(() => {
            this.loading = false;
          });
    },

    generateRandomId(length = 28) {

      if (!length) {
        length = 28
      }

      length = Number(length)

      const characters = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
      let randomId = '';

      // 生成16位随机字符
      for (let i = 0; i < length; i++) {
        const randomIndex = Math.floor(Math.random() * characters.length);
        randomId += characters.charAt(randomIndex);
      }

      return randomId;
    },


    goToGayHub() {
      window.open(repo)
    },
    getOS() {
      let ua = navigator.userAgent,
          isWindowsPhone = /(?:Windows Phone)/.test(ua),
          isSymbian = /(?:SymbianOS)/.test(ua) || isWindowsPhone,
          isAndroid = /(?:Android)/.test(ua),
          isFireFox = /(?:Firefox)/.test(ua),
          isChrome = /(?:Chrome|CriOS)/.test(ua),
          isTablet = /(?:iPad|PlayBook)/.test(ua) || (isAndroid && !/(?:Mobile)/.test(ua)) || (isFireFox && /(?:Tablet)/.test(ua)),
          isPhone = /(?:iPhone)/.test(ua) && !isTablet,
          isPc = !isPhone && !isAndroid && !isSymbian;

      return {
        isTablet: isTablet,
        isPhone: isPhone,
        isAndroid: isAndroid,
        isPc: isPc
      };
    },
    getBodyClass() {
      return this.isPc ? 'body-center body-width-pc' : 'body-center'
    },
    onCopy() {
      this.$message.success("复制成功!");
    },
    changeDisableStatus(event) {
      this.$refs.shortUrl.disabled = false
    }
  }
  ,
}
;
</script>
<style scoped>
.body-center {
  width: 40%;
  position: absolute;
  left: 50%;
  top: 35%;
  transform: translate(-50%, -50%);
  text-align: center;
}

.body-width-pc {
  width: 80%;
}

.body-width-mb {
  width: 90%;
}

.el-input {
  margin-top: 20px;
}
</style>
